/* eslint-disable i18n-scan/no-country-dependency */
import { serverData } from 'utils/server-data'

export const REPLACE_CARD_REASONS = {
  // Card lost or not received
  LOST: 'LOST',
  // Card used without permission
  STOLEN: 'STOLEN',
  // Combined lost/stolen — used by digital-only flows to skip ChooseReasonPage via URL param
  LOST_OR_STOLEN: 'LOST_OR_STOLEN',
  // Card damaged
  DAMAGED: 'DAMAGED',
  // Request physical card for digital only card
  GET_PHYSICAL_CARD: 'GET_PHYSICAL_CARD',
  // Name change on card
  NAME_CHANGE: 'NAME_CHANGE',
}

export const MANAGE_CARD_ACTIONS = {
  LOCK_OR_UNLOCK_CARD: 'LOCK_OR_UNLOCK_CARD',
  VIEW_PIN: 'VIEW_PIN',
  CREATE_PIN: 'CREATE_PIN',
  CHANGE_PIN: 'CHANGE_PIN',
  ADD_CASH: 'ADD_CASH',
  FIND_ATM: 'FIND_ATM',
  GET_PHYSICAL_CARD: 'GET_PHYSICAL_CARD',
  REPORT_LOST_OR_DAMAGED: 'REPORT_LOST_OR_DAMAGED',
  REPORT_LOST_OR_DAMAGED_DIGITAL: 'REPORT_LOST_OR_DAMAGED_DIGITAL',
  CANCEL_CARD: 'CANCEL_CARD',
}

const getOperationsDisabledOnLockedState = () => {
  const country = (serverData as any)?.locality?.country
  const operationsList = ['VIEW_PIN', 'CHANGE_PIN', 'ADD_CASH', 'FIND_ATM', 'GET_PHYSICAL_CARD']

  if (country === 'US') {
    operationsList.concat(['REPORT_LOST_OR_DAMAGED', 'REPORT_LOST_OR_DAMAGED_DIGITAL'])
  }
  return operationsList
}

export const mapOperationWithMetadataByDisabledStatus = (actionObject) => {
  let operationList = []
  const disabledOperationList = getOperationsDisabledOnLockedState()
  for (let key in actionObject) {
    const operation = actionObject[key]
    if (!disabledOperationList.includes(operation)) {
      operationList.push({ operation })
    }
  }
  return operationList
}

export const MANAGE_CARD_OPERATION = Object.values(MANAGE_CARD_ACTIONS).map((operation) => ({
  operation,
  disabled: false,
}))

export const LOCKED_PPDC_OPERATION = mapOperationWithMetadataByDisabledStatus(MANAGE_CARD_ACTIONS)
